/* eslint-disable no-undef */
import React from 'react';
import { Link } from 'react-router-dom';

import {
  Cards,
  CardHeader,
  CardBody,
  WrapperCardsCompanies,
  CardCompany,
  TitleCardsCompanies,
  CardFooter,
} from './style';

export default function CardUserList({ user }) {
  return (
    <Cards>
      <CardHeader accessMode={user.accessMode} isActive={user.isActive}>
        <h3>
          {user.name} {!user.isActive && ' (Inativo)'}
        </h3>
        <h4>
          Nível de Acesso: {user.accessMode === process.env.REACT_APP_DEV_ACCESS && 'Desenvolvedor'}
          {user.accessMode === process.env.REACT_APP_USER_SINCRONIZA_ACCESS && 'Prestador Sincroniza'}
          {user.accessMode === process.env.REACT_APP_ADMIN_SINCRONIZA_ACCESS && 'Administrador Sincroniza'}
          {user.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS && 'Suporte Sincroniza'}
          {user.accessMode === process.env.REACT_APP_USER_SPA_ACCESS && 'Colaborador S.P.A'}
          {user.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS && 'Administrador S.P.A'}
        </h4>
      </CardHeader>
      <CardBody>
        <p>
          <strong>E-mail: </strong>
          {user.email}
        </p>
        <p>
          <strong>Data de Cadastro: </strong>
          {user.createdAt.substring(0, 10).split('-').reverse().join('/')}
        </p>
      </CardBody>
      <TitleCardsCompanies>Empresa(s) em que presta serviço(s):</TitleCardsCompanies>
      <WrapperCardsCompanies>
        {user.company.map((comp, index) => {
          return (
            <CardCompany key={index + 1}>
              <h4>{comp.companyId.name}</h4>
              <p>
                <strong>Categoria: </strong> {comp.companyId.category}
              </p>
              <p>
                <strong>CNPJ: </strong>
                {comp.companyId.cnpj}
              </p>
            </CardCompany>
          );
        })}
      </WrapperCardsCompanies>
      <CardFooter>
        <Link to={`/editar-usuario/${user._id}`}>Editar</Link>
      </CardFooter>
    </Cards>
  );
}
